module.exports = __webpack_public_path__ + "static/media/test1.2ab3b6a1.png";